export const firstCharControl = (firstChar, equalNumber) => {
  if (!firstChar || !equalNumber) return false;
  return firstChar !== equalNumber;
};
